<template>
  <div class="">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  name: 'create-qr-code',
  props: {
    url: String
  },
  data () {
    return {}
  },
  watch: {
    url (val) {
      if (val) {

      }
    }
  },
  methods: {
    init (str) {
      let canvas = this.$refs.canvas
      QRCode.toCanvas(canvas, str, (error) => {
        if (error) console.error(error)
        console.log('success!')
      })
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus" scoped></style>
